import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from '@ingka/text';
import classes from './CoworkerDetails.module.scss';

const CoworkerData = ({ title, data }: { title?: string; data: number | string | null | undefined; }) => {
    const { t } = useTranslation();

    return (
        <div className={classes.value}>
            <Text data-testid="coworker-details-title" textStyle="Heading.XS">{title && t(title)}</Text>
            <Text data-testid="coworker-details-value" textStyle="Body.M">{data || t('N/A')}</Text>
        </div>
    );
};

export default CoworkerData;
